module.exports = __webpack_public_path__ + "img/fotostrommen.75f78cdc.jpg";